// Selector de período de "Mi Trabajo" — el backend nunca conoce estos
// presets, sólo recibe `desde`/`hasta` explícitos (evita duplicar "qué es
// esta semana" en dos lenguajes). Función pura, mismo criterio que
// colorSemantico.ts. La aritmética interna sigue en UTC (getUTCDay,
// Date.UTC, etc.) — lo único que cambió es que `hoy` ya no es el instante
// UTC crudo sino `hoyComoFechaUtc()` (shared/timezone.ts), que representa
// medianoche UTC del día calendario correcto en Mendoza. Antes, entre las
// 21:00 y las 24:00 hora Mendoza, "Hoy"/"Esta semana" ya mostraban el rango
// del día/semana siguiente.
import { hoyComoFechaUtc } from "../../shared/timezone";

export type TipoPeriodo =
  | "hoy"
  | "manana"
  | "semana"
  | "semana_proxima"
  | "mes"
  | "mes_proximo"
  | "personalizado";

export interface RangoPeriodo {
  desde: string;
  hasta: string;
}

function iso(fecha: Date): string {
  return fecha.toISOString().substring(0, 10);
}

function sumarDias(fecha: Date, dias: number): Date {
  return new Date(fecha.getTime() + dias * 86_400_000);
}

// Lunes de la semana (ISO, lunes-domingo) que contiene `fecha`.
function inicioSemana(fecha: Date): Date {
  const dia = fecha.getUTCDay(); // 0 = domingo
  const offset = dia === 0 ? -6 : 1 - dia;
  return sumarDias(fecha, offset);
}

function rangoMes(anio: number, mes: number): RangoPeriodo {
  const primero = new Date(Date.UTC(anio, mes, 1));
  const ultimo = new Date(Date.UTC(anio, mes + 1, 0));
  return { desde: iso(primero), hasta: iso(ultimo) };
}

export function calcularRangoPeriodo(tipo: TipoPeriodo, hoy: Date = hoyComoFechaUtc()): RangoPeriodo {
  switch (tipo) {
    case "hoy": {
      const f = iso(hoy);
      return { desde: f, hasta: f };
    }
    case "manana": {
      const f = iso(sumarDias(hoy, 1));
      return { desde: f, hasta: f };
    }
    case "semana": {
      const lunes = inicioSemana(hoy);
      return { desde: iso(lunes), hasta: iso(sumarDias(lunes, 6)) };
    }
    case "semana_proxima": {
      const lunes = sumarDias(inicioSemana(hoy), 7);
      return { desde: iso(lunes), hasta: iso(sumarDias(lunes, 6)) };
    }
    case "mes":
      return rangoMes(hoy.getUTCFullYear(), hoy.getUTCMonth());
    case "mes_proximo": {
      const anio = hoy.getUTCMonth() === 11 ? hoy.getUTCFullYear() + 1 : hoy.getUTCFullYear();
      const mes = (hoy.getUTCMonth() + 1) % 12;
      return rangoMes(anio, mes);
    }
    case "personalizado": {
      // El propio SelectorPeriodo maneja desde/hasta con su propio estado
      // para este caso; este valor por defecto sólo cubre la inicialización.
      const f = iso(hoy);
      return { desde: f, hasta: f };
    }
  }
}
